// extracted by mini-css-extract-plugin
export var activityContainer = "_mn-0";
export var typingIndicatorContainer = "_mn-1";
export var typingIndicatorDot = "_mn-2";
export var wave = "_mn-3";